// extracted by mini-css-extract-plugin
export var black = "_1m-6";
export var brand = "_1m-1";
export var ddefault = "_1m-0";
export var error = "_1m-3";
export var gray = "_1m-2";
export var highContrast = "_1m-8";
export var outline = "_1m-7";
export var success = "_1m-5";
export var warning = "_1m-4";